import AdminLayout from "../components/AdminLayout";
import { useApp } from "../context/AppContext";

export default function AdminReports({ navigate }) {
  const { applications } = useApp();
  const byService = {}, byStatus = {Pending:0,Approved:0,Rejected:0};
  applications.forEach(a => {
    byService[a.service_type] = (byService[a.service_type]||0)+1;
    byStatus[a.status] = (byStatus[a.status]||0)+1;
  });
  const maxSvc = Math.max(...Object.values(byService),1);
  const total  = applications.length||1;

  const BarRow = ({label,count,max,color}) => (
    <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:10}}>
      <div style={{fontSize:12,color:"#1a2540",width:180,flexShrink:0}}>{label}</div>
      <div style={{flex:1,background:"#f0f3f9",borderRadius:6,height:24,overflow:"hidden"}}>
        <div style={{height:"100%",borderRadius:6,background:color||"#1f4e79",width:`${(count/max)*100}%`,transition:"width 0.6s ease"}}/>
      </div>
      <div style={{fontSize:12,fontWeight:600,color:"#0d1f3c",width:28,textAlign:"right"}}>{count}</div>
    </div>
  );

  const Card = ({icon,title,children}) => (
    <div style={{background:"#fff",borderRadius:14,border:"1px solid #e4e9f0",overflow:"hidden"}}>
      <div style={{padding:"18px 22px",borderBottom:"1px solid #eaeef5",display:"flex",alignItems:"center",gap:10,background:"linear-gradient(135deg,#fafbfd,#fff)"}}>
        <span style={{fontSize:18}}>{icon}</span>
        <h2 style={{fontFamily:"'Cormorant Garamond',serif",fontSize:18,fontWeight:600,color:"#0d1f3c"}}>{title}</h2>
      </div>
      <div style={{padding:22}}>{children}</div>
    </div>
  );

  return (
    <AdminLayout navigate={navigate} active="reports" title="Reports & Analytics">
      {/* TOP STATS */}
      <div className="rgrid-3" style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:16,marginBottom:24}}>
        {[[applications.length,"Total Applications","linear-gradient(90deg,#4a7fb5,#8a9fc4)"],[byStatus.Approved,"Approved","linear-gradient(90deg,#22c55e,#4ade80)"],[byStatus.Pending,"Pending","linear-gradient(90deg,#f59e0b,#fbbf24)"]].map(([v,l,col])=>(
          <div key={l} style={{background:"#fff",borderRadius:12,padding:"18px 20px",border:"1px solid #e4e9f0",position:"relative",overflow:"hidden",textAlign:"center"}}>
            <div style={{position:"absolute",top:0,left:0,right:0,height:3,background:col}}/>
            <div style={{fontFamily:"'Cormorant Garamond',serif",fontSize:36,fontWeight:700,color:"#0d1f3c"}}>{v}</div>
            <div style={{fontSize:11,letterSpacing:"1.5px",textTransform:"uppercase",color:"#6b7a90",marginTop:4}}>{l}</div>
          </div>
        ))}
      </div>

      <div className="rgrid-2" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:20,marginBottom:20}}>
        <Card icon="📊" title="By Service Type">
          {Object.keys(byService).length>0 ? Object.entries(byService).map(([s,c])=>(
            <BarRow key={s} label={s} count={c} max={maxSvc}/>
          )) : <p style={{fontSize:13,color:"#6b7a90",textAlign:"center",padding:20}}>No data yet</p>}
        </Card>

        <Card icon="📈" title="By Status">
          <BarRow label="⏳ Pending"  count={byStatus.Pending}  max={total} color="#f59e0b"/>
          <BarRow label="✅ Approved" count={byStatus.Approved} max={total} color="#22c55e"/>
          <BarRow label="❌ Rejected" count={byStatus.Rejected} max={total} color="#ef4444"/>
        </Card>
      </div>

      {/* RECENT TABLE */}
      <div style={{background:"#fff",borderRadius:14,border:"1px solid #e4e9f0",overflow:"hidden"}}>
        <div style={{padding:"18px 22px",borderBottom:"1px solid #eaeef5",background:"linear-gradient(135deg,#fafbfd,#fff)"}}>
          <h2 style={{fontFamily:"'Cormorant Garamond',serif",fontSize:18,fontWeight:600,color:"#0d1f3c"}}>Recent Applications</h2>
        </div>
        {applications.length>0 ? (
          <div style={{overflowX:"auto"}}>
            <table style={{width:"100%",borderCollapse:"collapse"}}>
              <thead style={{background:"#f6f8fc"}}>
                <tr>{["App ID","Applicant","Service","Destination","Agent","Status"].map(h=>(
                  <th key={h} style={{padding:"11px 14px",textAlign:"left",fontSize:10,letterSpacing:"1.5px",textTransform:"uppercase",color:"#8a9bb5",fontWeight:600,borderBottom:"1px solid #eaeef5"}}>{h}</th>
                ))}</tr>
              </thead>
              <tbody>
                {[...applications].reverse().slice(0,10).map(app=>(
                  <tr key={app.id} style={{borderBottom:"1px solid #f0f3f9"}}>
                    <td style={{padding:"12px 14px"}}><strong style={{fontFamily:"'Cormorant Garamond',serif",color:"#0d1f3c",fontSize:13}}>{app.id}</strong></td>
                    <td style={{padding:"12px 14px",fontSize:13}}>{app.full_name}</td>
                    <td style={{padding:"12px 14px"}}><span style={{background:"#e0ecff",color:"#2563eb",padding:"3px 8px",borderRadius:6,fontSize:11,fontWeight:500}}>{app.service_type}</span></td>
                    <td style={{padding:"12px 14px",fontSize:13}}>{app.destination}</td>
                    <td style={{padding:"12px 14px",fontSize:13}}>{app.agent_name}</td>
                    <td style={{padding:"12px 14px"}}>
                      <span style={{display:"inline-flex",alignItems:"center",gap:4,padding:"4px 10px",borderRadius:20,fontSize:11,fontWeight:600,background:{Pending:"#fef3e2",Approved:"#dcfce7",Rejected:"#fee2e2"}[app.status],color:{Pending:"#d97706",Approved:"#16a34a",Rejected:"#dc2626"}[app.status]}}>
                        {{Pending:"⏳",Approved:"✅",Rejected:"❌"}[app.status]} {app.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div style={{padding:50,textAlign:"center"}}><div style={{fontSize:44,marginBottom:12}}>📭</div><p style={{fontSize:13,color:"#6b7a90"}}>No applications yet.</p></div>
        )}
      </div>
    </AdminLayout>
  );
}
